export class Note {
  constructor(
    public id: string,
    public text: string,
    public status?: boolean
  ) { }
}
